import { render, staticRenderFns } from "./PromoProButton.vue?vue&type=template&id=2fc709ee"
import script from "./PromoProButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromoProButton.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports